<template>
  <v-container fluid class="pa-0">
    <RouteListItem :node="{
      name: node.name,
      meta: {
        displayName: $t('servicesystem.pages.page_titles.job_my_jobs'),
        icon: 'mdi-briefcase-account',
        count: 0,
        params: { filter: 'my' }
      }
    }">
    </RouteListItem>

    <RouteListItem :node="{
      name: node.name,
      meta: {
        displayName: $t('servicesystem.pages.page_titles.job_parts_jobs'),
        icon: 'mdi-fridge-alert',
        count: 0,
        params: { filter: 'parts' }
      }
    }">
    </RouteListItem>

    <v-progress-linear v-if="StatusLoading" indeterminate height="1">
    </v-progress-linear>
    <v-divider v-else style="border-color: rgb(151 151 151 / 12%);" />
    <StatusRouteListItem v-for="(status, index) in StatusList" :key="index" :status="status" :node="node">
    </StatusRouteListItem>
    <!--
    <v-divider style="border-color: rgb(151 151 151 / 12%);" />
    <template v-for="(filter) in CustomJobListFilterList">
      <RouteListItem :key="filter.name"
                     :node="{
                      name: node.name,
                      meta: { 
                        displayName: filter.name, 
                        icon: filter.icon,
                        params: { statusId: undefined, subStatusId: undefined, filterId: filter.name },
                        query: {...filter.query, filter: undefined}
                      }
                    }">
      </RouteListItem>
    </template>
<RouteListItem :node="{
                      name: node.name,
                      meta: { 
                        displayName: 'New custom filter', 
                        icon: 'mdi-plus',
                        params: { statusId: undefined, subStatusId: undefined, filterId: 'new' },
                        query: {filter: 'filter' }
                      }
                    }">
</RouteListItem>
-->
  </v-container>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import StatusRouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Status.vue";

export default {
  name: "RouteListItem_Status",
  props: {
    node: Object,
  },
  components: {
    RouteListItem,
    StatusRouteListItem,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {
    StatusList() {
      return this.$store.getters["LookUpStore/JobStatusList"]?.filter((x) => x.Id < 100);
    },

    StatusLoading() {
      return this.$store.getters["BackgroundUpdater/Loading"]("StatusMap");
    },

    CustomJobListFilterList: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("CustomJobListFilterList");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "CustomJobListFilterList", value: update });
      },
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>